import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'
import {addParamsToUrl, athubAxios} from "@/util";

const project = new RestResource({server: ORGANIZATION_SERVER, resource: 'project'});

project.invalidate = (id, athubConfig) => {
    return athubAxios.put([project.server, project.resource, id, 'invalid'].join('/'), null, athubConfig);
};

project.revalidate = (id, athubConfig) => {
    return athubAxios.put([project.server, project.resource, id, 'valid'].join('/'), null, athubConfig);
};

project.findByCode = (code, athubConfig) => {
    return athubAxios.get(addParamsToUrl([project.server, project.resource, 'code'].join('/'), {
        code: code
    }), athubConfig);
};

project.findByName = (name, athubConfig) => {
    return athubAxios.get(addParamsToUrl([project.server, project.resource, 'name'].join('/'), {
        name: name
    }), athubConfig);
};

export default project;